import { defineMessages } from "react-intl";

export const messages = defineMessages({
  header: {
    id: "tagsMultiUpdateResult.header",
    defaultMessage: "Results",
  },
  headerErrors: {
    id: "tagsMultiUpdateResult.headerErrors",
    defaultMessage: "Errors list",
  },
  updatedTags: {
    id: "tagsMultiUpdateResult.updatedTags",
    defaultMessage: "Updated tags",
  },
  removedTags: {
    id: "tagsMultiUpdateResult.removedTags",
    defaultMessage: "Removed tags",
  },
  unchangedTags: {
    id: "tagsMultiUpdateResult.unchangedTags",
    defaultMessage: "Unchanged tags",
  },
  errors: {
    id: "tagsMultiUpdateResult.errors",
    defaultMessage: "Errors",
  },
  alertSomeErrors: {
    id: "tagsMultiUpdateResult.alertSomeErrors",
    defaultMessage: "The following rows/tags HAVE NOT BEEN PROCESSED",
  },
  errorTagTickerTitle: {
    id: "tagsMultiUpdateResult.errorTagTickerTitle",
    defaultMessage: "Tag ticker: {ticker}",
  },
  errorEngineTickerTitle: {
    id: "tagsMultiUpdateResult.errorEngineTickerTitle",
    defaultMessage: "Engine ticker: {ticker}",
  },
  errorDescriptionTitle: {
    id: "tagsMultiUpdateResult.errorDescriptionTitle",
    defaultMessage: "Error: {error}",
  },
  errorMissingTranslationDescription: {
    id: "tagsMultiUpdateResult.errorMissingTranslationDescription",
    defaultMessage: "Missing translation {locales}",
  },
  errorRepeatedTagDescription: {
    id: "tagsMultiUpdateResult.errorRepeatedTagDescription",
    defaultMessage: "Tag duplicated ({tagTicker}) in {relatedTicker}",
  },
  errorUsedTagDescription: {
    id: "tagsMultiUpdateResult.errorUsedTagDescription",
    defaultMessage:
      "Tag can't be deleted ({tagTicker}), it's already associated to {relatedTicker}",
  },
  errorPropertyTickerNotFound: {
    id: "tagsMultiUpdateResult.errorPropertyTickerNotFound",
    defaultMessage: "Property ticker {ticker} not found",
  },
  errorPropertyTickerWithoutPermission: {
    id: "tagsMultiUpdateResult.errorPropertyTickerWithoutPermission",
    defaultMessage: "Property ticker {ticker} not found",
  },
  errorInvalidTicker: {
    id: "tagsMultiUpdateResult.errorInvalidTicker",
    defaultMessage: "Ticker {ticker} has an invalid format",
  },
});
